export const getLibraryListQuery = /* GraphQL */ `
  query Query($organizationId: String!, $page: Int!, $pageSize: Int!) {
    libraries(organizationId: $organizationId, page: $page, pageSize: $pageSize) {
      id
      name
      photosCount
    }
  }
`
